import { render } from "./CanvasRightPanel.vue?vue&type=template&id=78da6e06&scoped=true"
import script from "./CanvasRightPanel.vue?vue&type=script&lang=js"
export * from "./CanvasRightPanel.vue?vue&type=script&lang=js"

import "./CanvasRightPanel.vue?vue&type=style&index=0&id=78da6e06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78da6e06"]])

export default __exports__